// extracted by mini-css-extract-plugin
export var addressFields = "_m8-0";
export var animationContainer = "_m8-1";
export var footer = "_m8-2";
export var lineItems = "_m8-3";
export var modalContent = "_m8-4";
export var orderName = "_m8-5";
export var strong = "_m8-6";
export var warning = "_m8-7";